import { useState } from "react";
import './AnimatedImage.scss';

const AnimatedImage = ({ src, alt = "", className = ""}) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <img
            onLoad={() => setLoaded(true)}
            alt={alt}
            src={src}
            className={`animated-image ${loaded ? "animated-image--visible" : "animated-image--hidden"} border ${className}`.trim()}
        />
    )
}

export default AnimatedImage;